import type { MailboxInfo } from 'owa-client-types';
import { CalendarCloudSettingType } from '../store/schema/CalendarCloudSettingType';
import getCalendarCloudSettings from './getCalendarCloudSettings';

/**
 * Gets the value for the show daylight saving time view cloud setting
 * @param mailboxInfo the mailbox info
 * @returns the value for the show daylight saving time view cloud setting
 */
export default function getShowDaylightSavingTimeViewCloudSetting(
    mailboxInfo: MailboxInfo
): boolean | undefined {
    const accountSettings = getCalendarCloudSettings(mailboxInfo);
    const showDaylightSavingTimeViewSetting = accountSettings.get(
        CalendarCloudSettingType.ShowDaylightSavingTimeView.toLowerCase()
    );

    return showDaylightSavingTimeViewSetting != null
        ? !!showDaylightSavingTimeViewSetting.value
        : undefined;
}
